/**
 * V70 Phase 3-C.1 — FE engine events → 서버 재계산용 입력 이벤트 변환.
 *
 * useAcidRainEngine.getInputEvents() 에서 호출. pure function 으로 분리하여 테스트 가능.
 *
 * 변환 규칙:
 *   - word_cleared → `{ type: 'cleared', elapsedMs, word: payload.text, combo: payload.combo }`
 *   - word_missed  → `{ type: 'missed',  elapsedMs, word: payload.text, combo: 0 }` (서버 재계산)
 *   - 그 외 GameEvent (start/end/difficulty_ramp/combo_broken/life_lost/word_spawn) — 무시
 *   - seq 는 **변환 대상 이벤트의 index** 순차 (0, 1, 2, ...)
 */
import type { GameEvent } from './types';

export interface AcidRainServerInputEvent {
  seq: number;
  type: 'cleared' | 'missed';
  elapsedMs: number;
  word: string;
  combo: number;
}

export function convertEngineEventsToServerInputEvents(
  events: readonly GameEvent[] | GameEvent[]
): AcidRainServerInputEvent[] {
  const out: AcidRainServerInputEvent[] = [];
  let seq = 0;
  for (const ev of events) {
    if (ev.type === 'word_cleared') {
      out.push({
        seq: seq++,
        type: 'cleared',
        elapsedMs: ev.tMs,
        word: String(ev.payload?.text || ''),
        combo: Number(ev.payload?.combo) || 0,
      });
    } else if (ev.type === 'word_missed') {
      out.push({
        seq: seq++,
        type: 'missed',
        elapsedMs: ev.tMs,
        word: String(ev.payload?.text || ''),
        combo: 0,
      });
    }
  }
  return out;
}
